import { render, staticRenderFns } from "./VenueView.vue?vue&type=template&id=319b0271&scoped=true"
import script from "./VenueView.vue?vue&type=script&lang=js"
export * from "./VenueView.vue?vue&type=script&lang=js"
import style0 from "./VenueView.vue?vue&type=style&index=0&id=319b0271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b0271",
  null
  
)

export default component.exports